export default [
  {
    itemType: 'group',
    colCount: 4,
    items: [
      {
        dataField: 'impressao',
        editorType: 'dxCheckBox',
        label: { text: 'Impressão' }
      },
      {
        template: 'fieldTela'
      },
      {
        template: 'fieldFuncionalidade'
      },
      {
        dataField: 'sequencia',
        label: { text: 'Sequência' }
      }
    ]
  },
  {
    itemType: 'group',
    colCount: 2,
    items: [
      {
        dataField: 'nome',
        label: { text: 'Nome' },
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório'
        }]
      },
      {
        dataField: 'urlDados',
        label: { text: 'URL Dados' },
        validationRules: [{
          type: 'required',
          message: 'URL Dados é obrigatório'
        }]
      }
    ]
  },
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'descricao',
        label: { text: 'Descrição' },
        editorType: 'dxTextArea',
        editorOptions: {
          height: 50
        },
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório'
        }]
      }
    ]
  },
  {
    itemType: 'group',
    colCount: 2,
    cssClass: 'mt-10',
    items: [
      {
        dataField: 'filtros',
        label: { text: 'Filtros' },
        editorType: 'dxTextArea',
        editorOptions: {
          height: 150
        }
      },
      {
        template: 'fieldReport'
        /* dataField: 'report',
        label: { text: 'Report' },
        editorType: 'dxTextArea',
        editorOptions: {
          height: 150
        },
        validationRules: [{
          type: 'required',
          message: 'Report é obrigatório'
        }] */
      }
    ]
  }
]
